// extracted by mini-css-extract-plugin
export default {"container404":"Page404_container404__clCLU","wrapper404":"Page404_wrapper404__rKPUP","description404":"Page404_description404__snIh1"};